





import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
@Component
export default class FitNavBarItem extends Vue {
  @Prop({ default: false }) active!: boolean;
  @Emit('click')
  click() {}
}
